import styled from "styled-components";

export const Wrapper = styled.div`
.filter{
    display: flex;
    justify-content: right;
    align-items: center;
}





`